module.exports = __webpack_public_path__ + "media/images/balance-product-drops-b932a41fd997a0c7854614695cde4ee0.png";